import { render, staticRenderFns } from "./material-usage.vue?vue&type=template&id=0268d436&scoped=true"
import script from "./material-usage.vue?vue&type=script&lang=js"
export * from "./material-usage.vue?vue&type=script&lang=js"
import style0 from "./material-usage.vue?vue&type=style&index=0&id=0268d436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268d436",
  null
  
)

export default component.exports